(function () {
  'use strict';

  /* @ngdoc object
   * @name events.vehicles.guests.list
   * @description
   *
   */
  angular
    .module('events.vehicles.guests.list', [
      'ui.router'
    ]);
}());
